export default __webpack_public_path__ + "static/media/oil-lubricant.b2e395ee.svg";